
import { createContext } from 'react';
import { Viewer } from '../../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ViewerContext = createContext<(Viewer | any)[]>([]);
